import type { ReactNode } from 'react';
import {
  Boxes,
  Building2,
  CalendarDays,
  Clock,
  CreditCard,
  DoorOpen,
  FileSignature,
  FileText,
  Home,
  Headset,
  Inbox,
  KanbanSquare,
  LayoutDashboard,
  LifeBuoy,
  Megaphone,
  Package,
  Plane,
  Receipt,
  Settings,
  GraduationCap,
  Target,
  UserSearch,
  Users,
  Wallet,
} from 'lucide-react';

/**
 * Icons live here, not in nav.ts: nav.ts is pure data with a unit test and no React, so the
 * permission logic can be tested without rendering anything. Shared by the desktop rail
 * (AppShell.tsx), the mobile drawer (MobileNav.tsx) and the asset flyout trigger, so the same
 * module shows the same icon everywhere.
 *
 * Keyed by each MODULE entry's `to` in `NAV` and `ADMIN_NAV` — only module rows render an icon;
 * pages inside a flyout are text. navIcons.test.ts fails if a module entry has no icon here, or if
 * an icon is left behind for an entry that no longer exists.
 */
export const ICONS: Record<string, ReactNode> = {
  // NAV — everyone
  '/': <Home className="size-4" />,
  '/inbox': <Inbox className="size-4" />,
  '/attendance': <CalendarDays className="size-4" />,
  '/learning': <GraduationCap className="size-4" />,
  '/leave': <FileText className="size-4" />,
  '/projects': <KanbanSquare className="size-4" />,
  '/payslip': <Wallet className="size-4" />,
  '/claims': <Receipt className="size-4" />,
  '/performance': <LayoutDashboard className="size-4" />,
  '/asset-management/my-assets': <Package className="size-4" />,
  '/my-details': <Building2 className="size-4" />,
  '/exit': <DoorOpen className="size-4" />,
  '/engage/announcements': <Megaphone className="size-4" />,
  '/helpdesk': <LifeBuoy className="size-4" />,

  // ADMIN_NAV
  '/admin/billing': <CreditCard className="size-4" />,
  '/admin/employee/list': <Users className="size-4" />,
  '/admin/organisation/company-profile': <Building2 className="size-4" />,
  '/attendance/admin': <Clock className="size-4" />,
  '/claims?tab=settlement': <Receipt className="size-4" />,
  '/admin/travel': <Plane className="size-4" />,
  '/admin/payroll': <Wallet className="size-4" />,
  '/admin/performance/insights': <Target className="size-4" />,
  '/admin/recruitment/requisitions': <UserSearch className="size-4" />,
  '/admin/offboarding': <DoorOpen className="size-4" />,
  '/admin/company-details': <Building2 className="size-4" />,
  '/admin/agreements': <FileSignature className="size-4" />,
  '/projects/all': <KanbanSquare className="size-4" />,
  '/asset-management/dashboard': <Boxes className="size-4" />,
  '/admin/helpdesk': <Headset className="size-4" />,
  '/admin/engage/announcements': <Megaphone className="size-4" />,
  '/admin/settings': <Settings className="size-4" />,
  '/admin/training': <GraduationCap className="size-4" />,
};
